import { render } from "./AddEdi.vue?vue&type=template&id=8cb4abba"
import script from "./AddEdi.vue?vue&type=script&lang=js"
export * from "./AddEdi.vue?vue&type=script&lang=js"

import "./AddEdi.vue?vue&type=style&index=0&id=8cb4abba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__